export default __webpack_public_path__ + "static/media/success-message-icon.8cff3e23.png";